exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wait[data-v-7ba5bd90] {\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n  margin-top: 300px;\n  opacity: 0.65;\n  z-index: 10;\n  position: fixed;\n  left: 0;\n  top: 0;\n}\n", ""]);

// exports
